import type { ImportedItem } from './types';
import { suggestDomainForName } from '../brandDomain';

/**
 * Import fallback: when a parsed item has a name but no web presence at all
 * (no web `identifiers` and no `url`), derive a primary `url` from the name via
 * the on-device brand→domain lookup. Items that already carry a URL/identifier
 * are returned untouched — we never overwrite what the file provided.
 *
 * Used by the import wizard so a file that is "just names" still lands usable
 * URLs (the user reviews/edits them in the review step before saving).
 */
export function fillMissingUrlsFromNames(items: ImportedItem[]): ImportedItem[] {
  return items.map((item) => {
    const hasWebIdentifier = item.identifiers?.some((i) => i.type === 'web' && i.value.trim());
    const hasUrl = !!item.url && item.url.trim().length > 0;
    if (hasWebIdentifier || hasUrl) return item;

    const domain = item.name ? suggestDomainForName(item.name) : null;
    return domain ? { ...item, url: domain } : item;
  });
}
